<!-- 圆环图 -->
<template>
    <div ref="main" style="width: 100%;height: 100%"></div>
</template>
<script setup>
import {ref, onMounted, watch} from "vue";
//  按需引入 echarts
import * as echarts from "echarts";

const main = ref() // 使用ref创建虚拟DOM引用，使用时用main.value
const props = defineProps({
    legend: {
        type: Boolean,
        default: false
    },
    // 换行清况
    title: {
        type: String,
        default: ''
    },
    // 依次展示的颜色
    color: {
        type: String,
        default: ""
    },
    data: {
        type: Array,
        default: []
    },
    // 显示方向 vertical == y轴数值 horizontal==x轴
    direction: {
        type: String,
        default: 'vertical'
    },
    axisLine: {
        type: Boolean,
        default: false
    },
    axisLabel: {
        type: Boolean,
        default: false
    },
    name: {
        type: String,
        default: ''
    },
    // 自定义tooltip
    customTooltip:{
        type:Boolean,
        default:false
    },
    customConfig:{
        type:Array,
        default:[]
    },
    notFixed:{
        type:Boolean,
        default:false
    },

})


watch(props, () => {
    init()
})

onMounted(
    () => {
        init()
    }
)

function init() {
    let myChart = echarts.init(main.value)
    let valueOptions = {
        name: props.name,
        type: 'value',
        boundaryGap: [0, 0.01],
        nameLocation: 'end',
        position: 'top',
        axisLine: {     // 隐藏 y 轴线
            show: false
        },
        axisLabel: {    // 隐藏刻度标签
            show: props.axisLabel
        },
        splitLine: {    // 隐藏分隔线
            show: false
        },
        nameGap: props.axisLine ? 20 : -80,
        offset: props.axisLine ? 0 : 20,
    }
    let xOptions = {
        type: 'category',
        data: props.data.map(item=>item.name),
        axisLine:{
            show:false
        },
        axisTick: {
            show: false  // 隐藏刻度
        },
    }

    let option = {
        title: {
            x: 'center',
            textStyle: {
                color: '#333',
                fontSize: 16,
                fontWeight: 'bold',
            }
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: props.direction === 'horizontal' ? {
                type: 'none',
            } : {
                lineStyle: {
                    color: props.color
                }
            },
            formatter: function (params) {
                if(props.customTooltip) {
                    let obj = props.data.find(item=>item.name===params[0].name)
                    let content = `<div style="font-size: 12px"><b>${params[0].name}<b>`;
                    props.customConfig.forEach(item=>{
                        let val = obj[item.key]
                        if(item.fixed) {
                            val = val.toFixed(item.fixed)
                        }
                        if(item.thousandth) {
                            val = val.toLocaleString()
                        }
                        content += `<div style="display: flex;justify-content: space-between;align-items: center"><b>${item.text}：</b><span style="font-weight: normal">${val}${item.unit?item.unit:''}</span></div>`
                    })
                    content += '</div>';

                    return content
                }
                return '<div>' + params[0].name + '<br />'+props.name+': ' + params[0].value + '</div>'; // 自定义 Tooltip 的内容，包括样式和数据项值
            },
        },
        legend: {
            show: false
        },
        grid: {
            left: '25',
            bottom: '10',
            containLabel: true
        },
        xAxis: props.direction === 'horizontal' ? valueOptions : xOptions,
        yAxis: props.direction === 'horizontal' ? xOptions : valueOptions,
        series: [
            {
                name: '2011',
                type: 'bar',
                data: props.data.map(item=>item.value.toFixed(props.notFixed?'0':2)),
                barWidth: 18,
                label: {
                    show: props.direction === 'horizontal',
                    position: 'right',
                    formatter: '{c}', // 使用 {c} 表示数据项的值
                    textStyle: {
                        color: '#666666'
                    }
                },
                itemStyle: {
                    borderRadius: [10, 10, 10, 10],
                    color: props.color
                }
            },
        ]
    };
    myChart.setOption(option)
}

</script>
